/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import EditIcon from '@mui/icons-material/Edit';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';

import { formatDate, isImageFile, isVideoFile } from '@utils';
import { PermissionsGate } from '@components';
import { SimpleMenu } from 'components/common/ui';
import { ImagesGalleryModal, Dialog } from 'components/common/modals';
import styles from './fileList.style';

const FileItem = ({
  file,
  files,
  loading,
  onClick,
  onDelete,
  onEdit,
  enablePreviewFile,
  showMenuItem = true,
}) => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [isImagesGalleryOpen, setIsImagesGalleryOpen] = useState(false);

  const handleCloseImagesGallery = () => {
    setIsImagesGalleryOpen(false);
  };

  const _handleClick = (e) => {
    e.stopPropagation();
    if (enablePreviewFile) {
      setIsImagesGalleryOpen(true);
    }
    onClick?.(file);
  };

  const _handleDelete = (e) => {
    e.stopPropagation();
    setOpenConfirmDialog(true);
  };

  const _handleCloseConfirmDialog = (e) => {
    e?.stopPropagation();
    setOpenConfirmDialog(false);
  };

  const _handleConfirmDelete = () => {
    onDelete(file);
  };

  const _handleEdit = (e) => {
    e?.stopPropagation();
    onEdit?.(file);
  };

  const _getFileName = () => {
    const firstUnderscoreIndex = file?.url?.indexOf('_');

    return (
      file?.filename ||
      file?.file?.name ||
      file?.url?.substring(firstUnderscoreIndex + 1)
    );
  };
  const fileName = _getFileName();
  const isImage = isImageFile(fileName);

  const isMedia = isVideoFile(fileName);
  const menuItems = [
    {
      name: 'Delete',
      icon: <DeleteIcon data-testid="DeleteIcon" sx={{ fontSize: 20 }} />,
      onClick: _handleDelete,
    },
  ];

  if (onEdit) {
    menuItems.push({
      name: 'Edit',
      icon: <EditIcon data-testid="EditIcon" sx={{ fontSize: 20 }} />,
      onClick: _handleEdit,
    });
  }

  return (
    <Box sx={styles.fileListItem}>
      <Box sx={styles.itemContentWrapper}>
        <Box
          onClick={_handleClick}
          sx={{
            ...styles.itemFileWrapper,
            ...(isImage && styles.itemImageWrapper),
          }}
        >
          {isImage ? (
            <Box
              sx={{
                ...styles.imageContainer,
                backgroundImage: `url("${encodeURI(file.uri || file.url)}")`,
              }}
            />
          ) : (
            <Box sx={styles.fileContainer}>
              {isMedia ? (
                <OndemandVideoIcon
                  sx={styles.icon}
                  data-testid="InsertDriveFileIcon"
                />
              ) : (
                <InsertDriveFileIcon
                  sx={styles.icon}
                  data-testid="InsertDriveFileIcon"
                />
              )}
            </Box>
          )}
        </Box>

        <Box sx={styles.itemInfoWrapper}>
          <Box sx={styles.itemName}>{fileName}</Box>

          <Box>
            <Typography variant="span" sx={styles.itemLabel}>
              {`Type: `}
            </Typography>
            <Typography title={file.type} variant="span" sx={styles.itemValue}>
              {file.type || '-'}
            </Typography>
          </Box>
          <Box>
            <Typography variant="span" sx={styles.itemLabel}>
              {`Uploaded at: `}
            </Typography>
            <Typography variant="span" sx={styles.itemValue}>
              {formatDate(file.createdAt, 'dd/MM/yyyy HH:mm')}
            </Typography>
          </Box>
        </Box>
        {showMenuItem && (
          <PermissionsGate>
            <SimpleMenu disabled={loading} list={menuItems} />
          </PermissionsGate>
        )}
      </Box>
      <Dialog
        title={`Delete ${isImage ? 'image' : 'file'}?`}
        message={`Are you sure you want to delete this ${
          isImage ? 'image' : 'file'
        }?`}
        isOpen={openConfirmDialog}
        onConfirm={_handleConfirmDelete}
        onClose={_handleCloseConfirmDialog}
        loading={loading}
        submitText="Delete"
        cancelText="Cancel"
      />
      <ImagesGalleryModal
        images={files}
        selectedImage={file}
        openModal={isImagesGalleryOpen && enablePreviewFile}
        closeModal={handleCloseImagesGallery}
      />
    </Box>
  );
};

export default FileItem;
